import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import React, { ForwardedRef } from "react";

import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { GROUP_PLAYER_COLUMNS, GROUP_PLAYER_ROWS, GroupWithRotatingSessions } from "../../../hooks/meetingMessagingBridge";
import { SecondaryScreenGrid } from "../grid/Grid";
import styles from "./Group.module.css";

export interface SecondaryScreenGroupProps {
  meeting: Meeting;
  groupWithRotatingSessions: GroupWithRotatingSessions;
  videoSessions: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData<any>>[];
  className?: string;
  style?: React.CSSProperties;
}

export interface SecondaryScreenGroupRef {}

export const SecondaryScreenGroup = React.forwardRef(
  ({ meeting, groupWithRotatingSessions, videoSessions, className, style }: SecondaryScreenGroupProps, forwardRef: ForwardedRef<SecondaryScreenGroupRef>) => {
    const { sessions, visibleSessions, group } = groupWithRotatingSessions;
    const remaining = sessions.length - visibleSessions.length;

    // ---------------------------------------------------------------------- //
    // ---------------------------  EFFECTS ----------------------------- //
    // ---------------------------------------------------------------------- //

    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    const classes = [styles.groupContainer];
    if (className) classes.push(className);
    return (
      <div key={`group_${group.id}`} className={classes.join(" ")} style={style}>
        <div className={styles.groupHeader}>
          Groupe
          <span className={styles.groupTitle}>{group.name?.toUpperCase()}</span>
          <div className={styles.groupBadge}>{visibleSessions.length}</div>
        </div>
        {visibleSessions.length ? (
          <SecondaryScreenGrid
            meeting={meeting}
            sessions={visibleSessions}
            videoSessions={videoSessions}
            mode="groups"
            grid={{
              row: GROUP_PLAYER_ROWS,
              column: GROUP_PLAYER_COLUMNS,
              gap: 8,
              autoAdjust: false
            }}
            showName={false}
            room={group}
          />
        ) : (
          <div style={{ flex: 1, width: "100%" }}>
            <div className={styles.emptyGroup}>Aucun utilisateur connecté</div>
          </div>
        )}
        {remaining > 0 && <div className={styles.groupRemainingUsersIndicator}>{`+${remaining}`}</div>}
      </div>
    );
  }
);
